/*
 * View for the scheduled status modal, where a status change can be scheduled or canceled
 */

define([
  "marionette",
  "jquery",
  "underscore",
  "moment",
  "messaging/messenger",
  "modules/topicsSplit/topic/topicScheduledStatusModal/template/topicScheduledStatusModalTemplate.html",
], function (Marionette, $, _, Moment, Messenger, TopicScheduledStatusModalTemplate) {
  "use strict";

  const TopicScheduledStatusModalView = {};

  TopicScheduledStatusModalView.topicScheduledStatusModalView = Marionette.ItemView.extend({
    template: TopicScheduledStatusModalTemplate,
    getChangeDate: function () {
      if (this.$el.find("#statusDatePicker").val().length > 0) {
        const date = this.$el.find("#statusDatePicker").datepicker("getDate");
        //Add in the time of day (default midnight) to the date
        const time = parseInt(this.$el.find("#startTime option:selected").val(), 10);
        return new Date(date.getTime() + time); //return timestamp
      } else {
        return null; //no date entered
      }
    },
    getStatus: function () {
      return parseInt(this.$el.find("#newStatus").val(), 10);
    },
    getStatusText: function () {
      return this.$el.find("#newStatus option:selected").text();
    },
    onBeforeRender: function () {
      //if a status is scheduled, create the i18n'ed message here
      const timestamp = this.model.get("statusTimestamp");
      if (timestamp) {
        const date = Messenger.reqres.request("get:formatted:date", timestamp);
        const time = Messenger.reqres.request("get:formatted:time", timestamp);
        const status = _.findWhere(this.model.statusArray, {
          statusId: this.model.get("statusId"),
        });
        const statusName = status ? status.statusName : "";
        this.model.scheduledMessage = $.t("topic.scheduledStatus.scheduledMessage", {
          date: date,
          time: time,
          status: statusName,
        });
      }
    },
    onRender: function () {
      this.$el.i18n();
      const format = Messenger.reqres.request("get:datepicker:date:format");
      const lang = Messenger.reqres.request("get:interface:language");
      this.$el.find("#statusDatePicker").datepicker({
        format: format,
        startDate: "+1d",
        autoclose: true,
        language: lang,
      });
    },
    modelEvents: {
      change: "render",
    },
    statusError: function (errorMessage) {
      this.$el
        .find("#statusError")
        .html('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    triggers: {
      "click #doneButton": "done",
      "click #scheduleStatusButton": "schedule",
      "click #deleteScheduledStatus": "delete:status",
    },
  });

  return TopicScheduledStatusModalView;
});
